export const PATHS = {
  ROOT: 'companies',
  ALL: 'companies/all',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
  getWagesByUserId: (userId: number) => `${PATHS.ROOT}/wages/${userId}`,
};
